"use strict";



var year = new Date().getFullYear();
var copyright = document.querySelector(".copyright a");
copyright.innerHTML = "©" + year + " - Julien Ma";



//___Swiper

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
var swiperOptions = {
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slidesPerView: 'auto',
    speed: 2500, 
    breakpoints: {
      0: {
        direction: 'horizontal',
      },
      1024: {
        speed: 3000, 
        direction: 'vertical',
      }
    }
    
};

var swiperOptionsdeux = {
  loop: true,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  slidesPerView: 'auto',
  speed: 2500, 
  breakpoints: {
    0: {
      direction: 'horizontal',
    },
    1024: {
      speed: 6000, 
      autoplay:{
        reverseDirection: true,
        waitForTransition:true,
      },
      direction: 'vertical',
    }
  }
  
};

setTimeout(() => {
    var swiper1 = new Swiper(".slider--clem", swiperOptions);
    var swiper2 = new Swiper(".slider--ju", swiperOptionsdeux);
}, 250);



import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

var gsap__hero = gsap.utils.toArray(".gsap__anima--one");
var gsap__anima = gsap.utils.toArray(".gsap__anima");
var gsap__animaOver = gsap.utils.toArray(".gsap__anima--over");
var hero = document.querySelector(".hero");

window.addEventListener(("load"),(e)=>{
  if(window.innerWidth < 744){
    gsap__heroAnima("25%");
    gsap__sectionAnima("25%");
  }else if(window.innerWidth>744){
    if( hero){
      gsap__heroAnima("50%");
    }
    if(hero){
      gsap__animaOver.forEach((section)=>{
        let text = section.querySelector(".gsap__explications");
        let image = section.querySelector(".gsap__image");
        gsap.timeline({
          duration: 1,
          scrollTrigger: {
            trigger: section,
            start: "40% 65%",
            toggleActions: "play none play none",
          }
        })
        .to(section,{ opacity:1, duration :1},">")
        .from(text,{ opacity:0, duration:2,delay:-1},">")
        .from(image,{ opacity:0, duration:2, y: -64, delay:-1},"<")
      })
      
      gsap__finover(4);
      gsap__finover(5);
    }
  }
})

function gsap__finover(i){
  gsap.to(gsap__anima[i],{
  duration: 1,
  opacity: 1,
  scrollTrigger: {
      trigger:gsap__anima[i],
      start: "50% 95%",
      toggleActions: "play none play none",
  }
});

}

function gsap__heroAnima(el){
  gsap.to((gsap__hero),{
      duration: 1.5,
      opacity: 1,
      scrollTrigger: {
          trigger:gsap__hero,
          start:  el+" bottom",
          toggleActions: "play none play none",
      } 
  })
}

function gsap__sectionAnima(el){
   gsap__anima.forEach(function(gsap__anima){
     gsap.to(gsap__anima,{
         duration: 1,
         opacity: 1,
         scrollTrigger: {
             trigger:gsap__anima,
             start:  el+" bottom",
             toggleActions: "play none play none",
         }
     });
   });
}